import styles from 'css/src/components/common/ui/ContentPlaceholder.module.scss';

import React from 'react';
import classNames from 'classnames';

/**
 * An animated container that should be used as a loading placeholder for content
 * yet to be rendered.
 * This component takes the full width and height of its parent.
 *
 * @type {React.FC<genericPlaceholderProps>}
 */

export function BaseContentPlaceholder({ className = '', styleProps = {} }) {
    return (
        <div
            className={classNames(styles['content-placeholder'], className)}
            style={{ ...styleProps }}
        />
    );
}

const BlockPlaceholder = () => <BaseContentPlaceholder className={styles['block']} />;

const CirclePlaceholder = ({ className = '', styleProps = {} }) => {
    return (
        <BaseContentPlaceholder
            className={classNames(styles['circle'], className)}
            styleProps={styleProps}
        />
    );
};

const SingleLineTextPlaceholder = ({ className = '', styleProps = {} }) => (
    <BaseContentPlaceholder
        className={classNames(styles['single-line-text'], className)}
        styleProps={styleProps}
    />
);

const ContentPlaceholder = React.memo(BaseContentPlaceholder);

/* Variations */
export const ContentPlaceholderBlock = React.memo(BlockPlaceholder);
export const ContentPlaceholderCircle = React.memo(CirclePlaceholder);
export const ContentPlaceholderSingleLineText = React.memo(SingleLineTextPlaceholder);

export default ContentPlaceholder;
